import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';

import ContentLibraryTable from './ContentLibraryTable';
import { TAB_NAMES } from './contants';
import AddTeachingPointModalWrapper from 'App/components/AddTeachingPointModal/AddTeachingPointModalWrapper';
import { queryClient } from 'Shared/queryClient';

const PageWrapper = styled.div`
    &.container-fluid {
        padding: 0;
    }
`;

const SubNavbar = styled.div`
    h1 {
        font-weight: 500;
        font-size: 18px;
        text-align: left;
        padding-left: 7.8em;
        margin-top: 2em;
        padding-bottom: 1em;
    }
`;

const TabList = styled.ul`
    list-style: none;
    text-align: left;
    padding-left: 10em;
    margin-bottom: 0;
`;

const TabItem = styled.li`
    color: var(--dusty);
    margin-right: 1.2em;
    display: inline-block;
    text-transform: uppercase;
    cursor: pointer;

    &:hover {
        color: var(--dove);
    }

    &.active {
        color: var(--gargoyle);
        border-bottom: 2px solid var(--matisse);
        line-height: 2;

        &:hover {
            color: var(--chimney);
        }
    }
`;

const SectionBackground = styled.div`
    border-top: 1.3px solid var(--snow);
`;

const ContainerWrapper = styled.div`
    align-items: left;
    margin-top: 1.5%;
    margin-left: 10em;
    margin-right: 10em;
    border-radius: 1%;
`;

const Spacing = styled.div`
    margin-top: 40px;
`;

const resetTeachingPointCache = () => {
    queryClient.invalidateQueries(['contentList', TAB_NAMES.TEACHING]);
};

const ContentLibrary = () => {
    const { search } = useLocation();
    const navigate = useNavigate();
    const queryParams = useMemo(() => new URLSearchParams(search), [search]);
    const selectedTab = queryParams.get('type') || TAB_NAMES.DRUG;

    useEffect(() => {
        if (!queryParams.get('type')) {
            navigate({ search: `?type=${TAB_NAMES.DRUG}` }, { replace: true });
        }
    }, [navigate, queryParams]);

    const onTabChange = (tabName) => {
        navigate({ search: `?type=${tabName}` });
    };

    return (
        <PageWrapper className="container-fluid page-wrapper">
            <SubNavbar>
                <TabList>
                    <TabItem
                        id="drug-monograph-tab"
                        className={selectedTab === TAB_NAMES.DRUG ? 'active' : ''}
                        onClick={() => onTabChange(TAB_NAMES.DRUG)}
                    >
                        Drug Monographs
                    </TabItem>
                    <TabItem
                        id="disease-monograph-tab"
                        className={selectedTab === TAB_NAMES.DISEASE ? 'active' : ''}
                        onClick={() => onTabChange(TAB_NAMES.DISEASE)}
                    >
                        Disease Monographs
                    </TabItem>
                    <TabItem
                        id="teaching-point-monograph-tab"
                        className={selectedTab === TAB_NAMES.TEACHING ? 'active' : ''}
                        onClick={() => onTabChange(TAB_NAMES.TEACHING)}
                    >
                        Teaching Point Monographs
                    </TabItem>
                </TabList>
            </SubNavbar>

            <SectionBackground>
                <ContainerWrapper>
                    <ContentLibraryTable selectedTab={selectedTab} key={selectedTab} />
                    <Spacing />
                    {selectedTab === TAB_NAMES.TEACHING && (
                        <AddTeachingPointModalWrapper loadTable={resetTeachingPointCache} />
                    )}
                </ContainerWrapper>
            </SectionBackground>
        </PageWrapper>
    );
};

export default ContentLibrary;
